import React, {useEffect} from 'react';
import {useState} from 'react';
import {isMobile} from 'react-device-detect';
import {Card, CardImg, CardImgOverlay, Button} from 'reactstrap';
import './marketingBannerBlockStyle.scss';
import Lottie from 'react-lottie';
import SolutionsBlock from '../SolutionsBlock/MainSolutions';
import {getFullPath} from '../ArticlePagesBlock/utilities';
import axios from 'axios';

export const MarketingBannerBlockMain = (props) => {
  const content = {
    mainHeading: props.contentData?.mainHeading?.value,
    secondaryHeading: props.contentData?.secondaryHeading?.value,
    backgroundImg: isMobile
      ? getFullPath(props.contentData?.backgroundImageMobile?.expandedValue?.url)
      : getFullPath(props.contentData?.backgroundImageDesktop?.expandedValue?.url),
    backupBackgroundImg: isMobile
      ? getFullPath(props.contentData?.backupBackgroundImageMobile?.expandedValue?.url)
      : getFullPath(props.contentData?.backupBackgroundImageDesktop?.expandedValue?.url),
    showButton: props.contentData?.showButton?.value,
    showAnimation: props.contentData?.showAnimation?.value,
    bannerButtonColor: props.contentData?.buttonDesign?.expandedValue?.[0]?.buttonDesignMode?.value,
    bannerButtonText: props.contentData?.buttonDesign?.expandedValue?.[0]?.text?.value,
    bannerButtonUrl: props.contentData?.bannerUrl?.value,
    animation: isMobile
      ? getFullPath(props.contentData?.bannerAnimationMobile?.value?.url)
      : getFullPath(props.contentData?.bannerAnimationDesktop?.value?.url),
  };
  const [animationShowState, setAnimationDisplay] = useState(content.showAnimation);
  const [imgSrc, setImgSrc] = useState(
    animationShowState ? content.backgroundImg : content.backupBackgroundImg ? content.backupBackgroundImg : content.backgroundImg,
  );
  const [jsonData, setJsonData] = useState(null);
  const isSolutionActive = props.contentData?.isSolutionActive?.value;

  useEffect(() => {
    axios({
      url: content.animation,
      responseType: 'json',
      credentials: 'include',
      mode: 'no-cors',
      headers: {
        Accept: 'application/json; odata=verbose',
      },
    })
      .then((response) => {
        setJsonData(response.data);
      })
      .catch((err) => handleImgError());
  }, []);

  const getButtonColorsClass = (btnColor) => {
    switch (btnColor) {
      case 0:
        return 'purple-button';
      case 1:
        return 'black-button';
      case 2:
        return 'white-button';
      default:
        return 'purple-button';
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: jsonData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const handleImgError = () => {
    let backImg = content.backupBackgroundImg ? content.backupBackgroundImg : content.backgroundImg;
    setImgSrc(backImg);
    setAnimationDisplay(false);
  };

  const handleClick = () => {
    if (content.bannerButtonUrl) {
      props.context.navigateTo(content.bannerButtonUrl);
    }
  };

  return (
    <div className='marketing-banner-project-parent-block'>
      <div className={isMobile ? 'marketing-banner-block-style-mobile' : 'marketing-banner-block-style'}>
        <Card inverse>
          <CardImg width={'100%'} height={isMobile ? '604px' : '595px'} src={imgSrc} onError={handleImgError} />
          <CardImgOverlay>
            <div className={`marketing-banner-main-container ${!animationShowState && 'backup'}`}>
              <div className='marketing-banner-text-container'>
                <p className='marketing-banner-main-heading' dangerouslySetInnerHTML={{__html: content.mainHeading}} />
                <p className='marketing-banner-secondary-heading' dangerouslySetInnerHTML={{__html: content.secondaryHeading}} />
                {isMobile && animationShowState && (
                  <div className='marketing-banner-animation-container'>
                    <Lottie options={defaultOptions} onError={handleImgError} />
                  </div>
                )}

                {content.showButton && (content.bannerButtonColor || content.bannerButtonText) && (
                  <Button
                    className={`marketing-banner-join-btn ${getButtonColorsClass(content.bannerButtonColor)}`}
                    onClick={handleClick}
                    style={{
                      cursor: content.bannerButtonUrl ? 'pointer' : 'default',
                    }}>
                    <span className='btn-text'>{content.bannerButtonText}</span>
                  </Button>
                )}
              </div>
              {!isMobile && animationShowState && (
                <div className='marketing-banner-animation-container'>
                  <Lottie options={defaultOptions} onError={handleImgError} />
                </div>
              )}
            </div>
          </CardImgOverlay>
        </Card>

        {isSolutionActive && <SolutionsBlock iContent={props.contentData?.businessSolutions?.expandedValue[0]} context={props.context} />}
      </div>
    </div>
  );
};
